module.exports = __webpack_public_path__ + "img/vip-wallet.92048bfe.png";